import { render, staticRenderFns } from "./TempConfigFormula.vue?vue&type=template&id=5f20aceb&scoped=true"
import script from "./TempConfigFormula.vue?vue&type=script&lang=js"
export * from "./TempConfigFormula.vue?vue&type=script&lang=js"
import style0 from "./TempConfigFormula.vue?vue&type=style&index=0&id=5f20aceb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20aceb",
  null
  
)

export default component.exports